<script lang="ts" module>
  export type CollapsibleContentProps = BaseProps & {
    transition?: boolean | SlideParams
  }
</script>

<script lang="ts">
  import { useActions } from "#lib/internal/helpers/useActions"
  import type { BaseProps } from "#lib/internal/types"
  import type { Snippet } from "svelte"
  import { slide, type SlideParams } from "svelte/transition"
  import { getCollapsibleRootContext } from "./CollapsibleRoot.svelte"

  type $$Props = CollapsibleContentProps

  interface Props {
    transition?: $$Props["transition"]
    children?: Snippet
    [key: string]: any
  }

  let { transition = undefined, children, ...rest }: Props = $props()

  function getParams(transition: $$Props["transition"]): SlideParams {
    if (!transition) {
      return {
        duration: 0,
      }
    }

    let transitionObj = typeof transition === "object" ? transition : {}
    return {
      duration: 300,
      ...transitionObj,
    }
  }

  const ctx = getCollapsibleRootContext()
</script>

{#if $ctx.open}
  <div
    {...rest}
    use:useActions={rest.use}
    data-state={$ctx.open ? "open" : "closed"}
    data-disabled={$ctx.disabled ? "true" : undefined}
    transition:slide|local={getParams(transition)}
  >
    {@render children?.()}
  </div>
{/if}
